import React from "react";

const Loading = () => {
    return (
        <div className="fixed top-0 right-0 w-full h-full bg--white/50 dark:bg-black/50 z-50 flex justify-center items-center">
        <div className="flex gap-x-4 justify-center items-center">
            <p className="text-gray-800 dark:text-white">در حال بارگذاری</p>
            <div
                className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-blue-500 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status">
                <span
                    className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                >Loading...</span>
            </div>
        </div>
    </div>
    )
}

export default Loading